module.exports = __webpack_public_path__ + "media/images/user1_logo-922f00a8ef6ab8d39fcf376463c63e17.png";